// @flow
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { saveAs } from 'file-saver';
import * as bookingCreators from '../../actions/bookings/bookingCreators';
import * as campaignsCreators from '../../actions/campaigns/campaignCreators';
import { getSetting } from '../../actions/settings/settingsCreators';
import { Grid, Row, Col, Button, Glyphicon } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import CampaignSidebar from './CampaignSidebar';
import CampaignHeader from '../../components/CampaignHeader';
import type { Dispatch } from 'redux';
import ReCAPTCHA from 'react-google-recaptcha';
import { Link } from 'react-router';
//import jsPDF from 'jspdf';
import LodgementForm from '../../images/AM1018_lodgement_form_final.jpg';
import LodgementFormPage2 from '../../images/AM1018_lodgement_form_final-page2.jpg';

type Params = {
  context: string,
  organisationId: number,
  campaignId: string | number
};

type Props = {
  params: Params,
  router: any,
  currentOrganisation: Object,
  currentLocation: Object,
  currentCampaign: Object,
  currentCampaignBooking: Object,
  settings: Object,
  authentication: Object,
  campaignDeliveryPoints: any,
  updateCurrentCampaign: (c: number, o: number) => Promise<*>,
  updateCurrentCampaignBooking: (c: number, o: number) => Promise<*>,
  updateCampaign: (c: Object, context: any, r: any) => Promise<any>,
  getCampaignBooking: (c: number, o: number) => Promise<*>,
  getCampaignAddressesCount: (
    c: number,
    o: number,
    limit: ?number
  ) => Promise<*>,
  addBooking: (
    booking: Object,
    organisationId: number,
    context: any,
    r: any
  ) => Promise<any>,
  getBooking: (bookingId: any, organisationId: number) => Promise<any>,
  getSetting: (s: string) => void,
  getCampaigns: Function,
  getBookingAddresses: Function,
  cloneCampaign: Function
};

type State = {
  loading: boolean,
  isDownloadingAddresses: boolean,
  isLoadingCampaignAddressesCount: boolean,
  loadedCampaignAddressesCountForId: ?number,
  currentStep: number,
  captcha: string,
  savedAndDownloaded: boolean,
  unitPrice: number,
  terms: boolean,
  csvOfAddresses: ?string,
  csvOfAddressesMessage: string,
  customPricing: boolean,
  priceBandLabel: string,
  savedBookingNumber: ?number,
  savedBookingId: any
};

class Campaigns extends React.Component<Props, State> {
  intervalId: IntervalID;

  constructor(props: Props) {
    super(props);
    this.state = {
      loading: true,
      isDownloadingAddresses: false,
      isLoadingCampaignAddressesCount: true,
      loadedCampaignAddressesCountForId: null,
      currentStep: 1,
      captcha: '',
      savedAndDownloaded: false,
      unitPrice: 0.98,
      terms: true,
      csvOfAddresses: null,
      csvOfAddressesMessage: '',
      customPricing: false,
      priceBandLabel: 'N/A',
      savedBookingNumber: null,
      savedBookingId: null
    };
  }

  componentDidMount() {
    const {
      params: { organisationId, campaignId },
      updateCurrentCampaign,
      updateCurrentCampaignBooking,
      getSetting,
      getCampaignAddressesCount
    } = this.props;

    getSetting('amProductTermsAndConditions');
    getSetting('amProductGuide');
    getSetting('indicativeAmRate');

    this.pollLocalStorage();

    // Load currentCampaign
    updateCurrentCampaign(parseInt(campaignId, 10), organisationId).then(() => {
      this.setState({ loading: false });
    });
    updateCurrentCampaignBooking(parseInt(campaignId, 10), organisationId).then(
      success => {
        const { booking } = success;
        this.setState({ loading: false });
        this.setState({
          savedBookingNumber:
            success.booking.booking &&
            success.booking.booking.id &&
            success.booking.booking.bookingNumber,
          savedBookingId: success.booking.booking && success.booking.booking.id
        });

        this.loadCampaignAddressesCount(
          parseInt(campaignId, 10),
          organisationId,
          booking && booking.booking
            ? booking.booking.totalNumberOfRecordsSaved
            : null
        );
        // Load currentOrganisation/currentLocation,
      }
    );
    this.props.getCampaigns(organisationId);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  componentWillReceiveProps(nextProps) {
    this.handleCurrentOrgChange(nextProps);
    this.handleCurrentLocationChange(nextProps);
    this.handleCampaignIdUpdate(nextProps);
  }

  loadCampaignAddressesCount = async (
    campaignId: number,
    organisationId: number,
    limit: ?number
  ) => {
    this.setState({
      isLoadingCampaignAddressesCount: true,
      loadedCampaignAddressesCountForId: null
    });

    try {
      await this.props.getCampaignAddressesCount(
        campaignId,
        organisationId,
        limit
      );
      this.setState({ loadedCampaignAddressesCountForId: campaignId });
    } catch (error) {
      this.setState({ loadedCampaignAddressesCountForId: null });
    } finally {
      this.setState({ isLoadingCampaignAddressesCount: false });
    }
  };

  handleCaptcha = (value: string) => {
    this.setState({ captcha: value });
  };

  handleTermsCheckboxChange(event) {
    this.setState({ terms: event.target.checked });
  }

  /*downloadBookingForm = () => {
    // after the booking is created we dont have the booking number so need to fetch the booking
    this.props
      .getBooking(this.state.savedBookingId, this.props.currentOrganisation.id)
      .then(success => {
        var doc = new jsPDF();
        var img = new Image(100, 200);
        img.src = LodgementForm;
        var imgPage2 = new Image(100, 200);
        imgPage2.src = LodgementFormPage2;

        doc.addImage(img, 'JPEG', 0, 0, 210, 300);
        doc.text(success.booking.bookingNumber, 55, 50);
        doc.addPage();
        doc.addImage(imgPage2, 'JPEG', 0, 0, 210, 300);
        doc.save(success.booking.bookingNumber + '-lodgement-form.pdf');
      });
  };*/

  saveAndDownload = async () => {
    const booking = {
      campaignId: parseInt(this.props.currentCampaign.id, 10),
      totalNumberOfRecordsSaved: parseInt(
        this.props.campaignDeliveryPoints,
        10
      ),
      dateBookingLodgedBy: '2019-02-20 23:01:39'
    };

    if (this.state.savedBookingId) {
      this.downloadBookingAddresses(
        this.state.savedBookingId,
        this.props.params.organisationId
      );
    } else {
      let response = await this.props.addBooking(
        booking,
        this.props.params.organisationId
      );
      await this.downloadBookingAddresses(
        response.data.id,
        this.props.params.organisationId,
        true
      );
    }
  };

  downloadBookingAddresses = async (
    bookingId,
    currentOrganisationId,
    deleteOnFail = false
  ) => {
    // after it successfully saves it set the savedBookingID in state so we can us it in the next call to get the addresses
    this.setState({
      savedBookingId: bookingId,
      isDownloadingAddresses: true,
      csvOfAddressesMessage: ''
    });
    try {
      // this call gets all the booking addresses and returns a CSV string
      let data = await this.props.getBookingAddresses(
        bookingId,
        currentOrganisationId,
        deleteOnFail
      );
      // if there is a message there has been a restrictions issue
      // such as address download limit reached
      if (data.message) {
        this.setState({
          savedAndDownloaded: false,
          csvOfAddresses: null,
          csvOfAddressesMessage: data.message
        });
      } else {
        // BEGIN:
        console.log('downloadBookingAddresses: raw data', data);
        const downloadUrl =
          typeof data === 'string' ? data : data && data.url ? data.url : null;
        console.log('downloadBookingAddresses: opening url', downloadUrl);

        if (downloadUrl && /^https?:\/\//i.test(downloadUrl)) {
          const openedWindow = window.open(downloadUrl, '_blank');
          console.log(
            'downloadBookingAddresses: window.open result',
            Boolean(openedWindow)
          );
          if (!openedWindow) {
            console.log(
              'downloadBookingAddresses: popup blocked, falling back to same tab'
            );
            window.location.assign(downloadUrl);
          }
        } else {
          console.log(
            'downloadBookingAddresses: invalid or missing download url'
          );
        }
        // END

        this.setState({
          savedAndDownloaded: true,
          csvOfAddresses: data,
          csvOfAddressesMessage: ''
        });
        const currentCampaign = this.props.currentCampaign;
        const currentOrganisationId = this.props.params.organisationId;
        currentCampaign.amLocked = true;
        currentCampaign.termsAndConditionsAccepted = true;
        await this.props.updateCampaign(currentCampaign, currentOrganisationId);
        let response = await this.props.getBooking(
          this.state.savedBookingId,
          currentOrganisationId
        );
        this.setState({
          savedBookingNumber: response.booking.bookingNumber
        });

        // if (!navigator.userAgent.match('CriOS')) {
        //   const addresses = new Blob([data], {
        //     type: 'text/csv;charset=utf-8'
        //   });
        //   saveAs(
        //     addresses,
        //     `booking-${response.booking.bookingNumber}-addresses.csv`
        //   );
        // } else {
        //   let csvContent = `data:text/csv;charset=utf-8,${data}`;
        //   let encodedUri = encodeURI(csvContent);
        //   const link = document.createElement('a');
        //   link.setAttribute('href', encodedUri);
        //   link.setAttribute('download', 'bookings.csv');
        //   if (document.body) {
        //     document.body.appendChild(link);
        //   }
        //   link.click();
        //   if (document.body) {
        //     document.body.removeChild(link);
        //   }
        // }
      }
    } catch (error) {
      const errorMessage =
        (error && error.data && (error.data.msg || error.data.message)) ||
        'Error getting Booking Addresses';

      this.setState({
        savedAndDownloaded: false,
        csvOfAddresses: null,
        csvOfAddressesMessage: errorMessage
      });
    } finally {
      this.setState({
        isDownloadingAddresses: false
      });
    }
  };

  handleCurrentOrgChange = (nextProps: Props) => {
    const {
      router,
      params: { context }
    } = this.props;

    const newUrlId = nextProps.params.organisationId;
    const currentOrgId = this.props.currentOrganisation.id;
    const newCurrentOrgId = nextProps.currentOrganisation.id;

    // state org has changed to something other than the new urlId
    const currentOrgHasChanged =
      currentOrgId !== newCurrentOrgId &&
      newCurrentOrgId !== parseInt(newUrlId, 10);

    if (currentOrgHasChanged) {
      if (context === 'sub-account') {
        // redirect to dashboard
        router.push('/');
      } else {
        // update url back to /campaigns
        router.push(`/customer/${newCurrentOrgId}/campaigns`);
      }
    }
  };

  handleCurrentLocationChange = nextProps => {
    // Update campaigns if currentLocation has changed
    const newCurrentLocation = nextProps.currentLocation;
    const currentLocation = this.props.currentLocation;
    const context = this.props.params.context;
    if (currentLocation.id !== newCurrentLocation.id) {
      if (context === 'sub-account') {
        // if context is location, redirect to /campaigns page
        this.props.router.push(
          `/sub-account/${newCurrentLocation.id}/campaigns`
        );
      }
    }
    // if context is customer, do nothing
  };

  handleCampaignIdUpdate = nextProps => {
    const campaignId = this.props.params.campaignId;
    let newCampaignId = nextProps.params.campaignId;

    // campaign Id in URL has changed
    if (newCampaignId !== campaignId) {
      const currentOrgId = this.currentOrgId();
      newCampaignId = parseInt(newCampaignId, 10);
      this.setState({
        loading: true,
        isLoadingCampaignAddressesCount: true,
        loadedCampaignAddressesCountForId: null
      });
      this.props
        .updateCurrentCampaign(newCampaignId, currentOrgId)
        .then(() => this.setState({ loading: false }));
      this.props
        .updateCurrentCampaignBooking(newCampaignId, currentOrgId)
        .then(success => {
          const booking = success && success.booking;
          this.setState({
            savedBookingNumber:
              booking && booking.booking && booking.booking.id
                ? booking.booking.bookingNumber
                : null,
            savedBookingId:
              booking && booking.booking ? booking.booking.id : null
          });

          return this.loadCampaignAddressesCount(
            newCampaignId,
            currentOrgId,
            booking && booking.booking
              ? booking.booking.totalNumberOfRecordsSaved
              : null
          );
        });
    }
  };

  currentOrgId = () => parseInt(this.props.params.organisationId, 10);

  cloneCampaign = campaign => {
    const { organisationId, context } = this.props.params;
    campaign &&
      campaign.id &&
      this.props.cloneCampaign(
        parseInt(campaign.id, 10),
        parseInt(organisationId, 10),
        context
      );
  };

  updateCampaign = desiredStep => {
    const updatedCampaign = {
      ...this.props.currentCampaign,
      statusTypeId: desiredStep
    };
    const redirect = true;

    this.props.updateCampaign(
      updatedCampaign,
      this.props.params.context,
      redirect
    );
  };

  pollLocalStorage = () => {
    this.intervalId = setInterval(() => {
      const currentCampaignRaw = localStorage.getItem(
        'reduxPersist:currentCampaign'
      );
      let currentCampaign;
      if (currentCampaignRaw) {
        currentCampaign = JSON.parse(currentCampaignRaw);
      }
      let currentStep;
      if (currentCampaign) {
        currentStep = currentCampaign.statusTypeId;
      }
      if (this.state.currentStep !== currentStep) {
        this.setState({ currentStep });
      }
    }, 1000);
  };

  render() {
    const {
      settings,
      currentOrganisation,
      currentCampaignBooking,
      currentCampaign,
      params,
      campaignDeliveryPoints,
      authentication: {
        user: { isInternalAdminUser, email }
      }
    } = this.props;
    const {
      csvOfAddressesMessage,
      savedAndDownloaded,
      savedBookingNumber,
      isDownloadingAddresses,
      isLoadingCampaignAddressesCount,
      loadedCampaignAddressesCountForId
    } = this.state;

    const currentCampaignId =
      params && params.campaignId ? parseInt(params.campaignId, 10) : null;
    const hasLoadedCurrentCampaignAddressesCount =
      currentCampaignId !== null &&
      loadedCampaignAddressesCountForId === currentCampaignId;
    const showCampaignAddressesCountSpinner =
      isLoadingCampaignAddressesCount ||
      !hasLoadedCurrentCampaignAddressesCount;

    let saveAndDownloadDisabled = !(this.state.captcha !== '');
    let step = 1;

    return (
      <Grid fluid>
        <Helmet>
          {params && !params.campaignId && currentOrganisation && (
            <title>
              Manage Campaigns | {currentOrganisation.name} | Campaign Targeter
            </title>
          )}
          {params && params.campaignId && currentOrganisation && (
            <title>
              Download Addresses and Lodgement Form | {currentOrganisation.name}{' '}
              | Campaign Targeter
            </title>
          )}
        </Helmet>
        <Row>
          <CampaignHeader
            params={this.props.params}
            currentStep={5}
            campaignStatus={this.props.currentCampaign.statusTypeId || 1}
            pdfUrl={
              settings && settings.campaignHelpPdf
                ? settings.campaignHelpPdf.value
                : ''
            }
            videoUrl={
              settings && settings.campaignHelpVideo
                ? settings.campaignHelpVideo.value
                : ''
            }
            campaignIsLocked={
              this.props.currentCampaign && this.props.currentCampaign.amLocked
            }
          />
        </Row>
        <Row>
          <Col sm={3} className="sidebar-wrapper">
            {/* $FlowFixMe */}
            <CampaignSidebar
              {...this.props}
              currentOrgId={this.props.params.organisationId}
              cloneCampaign={this.cloneCampaign}
            />
          </Col>
          <Col sm={6} className="generic-main-content-wrapper">
            <h1>Download Addresses and Lodgement Form</h1>
            <div className="lodgement-screen__sub-header-rapper">
              <h3>Addressed Mail</h3>
              <a
                className="lodgement-screen__product-guide"
                href={
                  settings &&
                  settings.amProductGuide &&
                  settings.amProductGuide.value
                }
                target="_blank"
              >
                ( Product Guide )
              </a>
            </div>
            {/*campaignDeliveryPoints will have a message if there is an error*/}
            {campaignDeliveryPoints.message && (
              <p className="error__message">{campaignDeliveryPoints.message}</p>
            )}
            {!campaignDeliveryPoints.message &&
              (showCampaignAddressesCountSpinner ||
                campaignDeliveryPoints !== '0') && (
                <div>
                  <p className="lodgement-screen__title">
                    {step++}. Read and accept the Addressed Mail Terms and
                    Conditions
                  </p>
                  {settings &&
                    settings.amProductTermsAndConditions &&
                    settings.amProductTermsAndConditions.value && (
                      <p className="ambooking_callout">
                        <a
                          href={
                            settings &&
                            settings.amProductTermsAndConditions &&
                            settings.amProductTermsAndConditions.value
                          }
                          target="_blank"
                        >
                          Terms and Conditions
                        </a>
                      </p>
                    )}
                  <br />
                  {!(isInternalAdminUser || currentCampaign.amLocked) && (
                    <span>
                      <p className="lodgement-screen__title">
                        {step++}. Complete robot check
                      </p>
                      <ReCAPTCHA
                        sitekey="6LeHipAUAAAAAHofrVN9r_7cKHmHUC4JFucjKKlU"
                        onChange={this.handleCaptcha}
                      />
                      <br />
                    </span>
                  )}
                  <p className="lodgement-screen__title">
                    {step++}. Download the{' '}
                    {showCampaignAddressesCountSpinner ? (
                      <Glyphicon
                        glyph="refresh"
                        style={{
                          animation: 'Select-animation-spin 1s infinite linear'
                        }}
                      />
                    ) : (
                      campaignDeliveryPoints
                    )}{' '}
                    addresses for your campaign.
                    <Button
                      className="btn btn-primary pull-right download-icon"
                      onClick={this.saveAndDownload}
                      disabled={
                        isLoadingCampaignAddressesCount ||
                        isDownloadingAddresses ||
                        !(
                          isInternalAdminUser ||
                          currentCampaign.amLocked ||
                          (!isInternalAdminUser &&
                            saveAndDownloadDisabled !== true)
                        )
                      }
                    >
                      <Glyphicon
                        glyph={
                          isDownloadingAddresses ? 'refresh' : 'download-alt'
                        }
                        style={
                          isDownloadingAddresses
                            ? {
                                animation:
                                  'Select-animation-spin 1s infinite linear'
                              }
                            : undefined
                        }
                      />
                    </Button>
                  </p>
                  {csvOfAddressesMessage && (
                    <p className="booking-error-message">
                      Error: {csvOfAddressesMessage}
                    </p>
                  )}
                </div>
              )}
            <br />
            {(savedAndDownloaded || currentCampaign.amLocked) && (
              <div>
                {/*
                <p className="lodgement-screen__title">
                  {step++}. Download and save the Acquisition Mail Lodgement
                  Form.
                  <Button
                    className="btn btn-primary pull-right download-icon"
                    onClick={this.downloadBookingForm.bind(this)}
                  >
                    <Glyphicon glyph="download-alt" />
                  </Button>
                </p>
                <br />
                */}
                <p className="lodgement-screen__title">
                  {step++}. Prepare and Lodge your Addressed Mail.
                </p>
                <p className="lodgement-screen__indent-section">
                  Instructions have been emailed to {email}.<br />
                </p>
                <p className="lodgement-screen__indent-section">
                  A summary of your booking can be viewed at:
                  <br />
                  {savedBookingNumber && (
                    <Link
                      to={
                        params.context === 'customer'
                          ? `/customer/${currentOrganisation.id}/bookings/${
                              currentCampaignBooking &&
                              currentCampaignBooking.id
                                ? currentCampaignBooking.id
                                : this.state.savedBookingId
                            }`
                          : `/sub-account/${
                              this.props.currentOrganisation.id
                            }/bookings/${
                              currentCampaignBooking &&
                              currentCampaignBooking.id
                                ? currentCampaignBooking.id
                                : this.state.savedBookingId
                            }`
                      }
                      target="_blank"
                    >
                      AM Job Id No:{' '}
                      {savedBookingNumber ? savedBookingNumber : 'View Booking'}
                    </Link>
                  )}
                </p>
                <br />
                <Link
                  to={
                    this.props.params.context === 'customer'
                      ? `/customer/${this.props.params.organisationId}/campaigns/${this.props.params.campaignId}/review`
                      : `/sub-account/${this.props.params.organisationId}/campaigns/${this.props.params.campaignId}/review`
                  }
                  className="btn btn-primary pull-left"
                >
                  Back
                </Link>
                <Link to="/" className="btn btn-primary pull-right">
                  Close
                </Link>
              </div>
            )}
          </Col>
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    campaigns: state.campaigns,
    currentCampaign: state.currentCampaign,
    currentCampaignBooking: state.currentCampaignBooking,
    currentOrganisation: state.currentOrganisation,
    currentInsightSet: state.currentInsightSet,
    currentLocation: state.currentLocation,
    campaignDeliveryPoints: state.campaignDeliveryPoints,
    settings: state.settings,
    authentication: state.authentication
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators(
    {
      ...campaignsCreators,
      ...bookingCreators,
      getSetting
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Campaigns);



// WEBPACK FOOTER //
// ./src/containers/campaigns/CampaignFinaliseAMBooking.js